<template>
  <div 
    class="card" 
    @mouseenter="hoverId = item.codigo"
    @mouseleave="hoverId = null"
    :style="{width: '200px'}"
  >
    <div
      ref="current-speaker"
      class="speaker-img"
      :style="{
        '--zoom-size': `${settings.layout.zoom || '125'}%`,
        backgroundImage: `url('${item.url_avatar}')`,
      }"    
    >
      <div 
        class="overlapping px-2 py-1" 
        :style="{
          height: item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo)  ? '95px': '62px',
          width: hoverId === item.codigo ? '162px': '152px',
          backgroundColor: settings.layout.color1 || '#FFFFFF'
        }"
      >
        <span 
          class="titleCard" 
          :style="{
            color: settings.layout['text-color1'] || '#24252D', 
            fontSize: item.nome.length > 15 ? '13px': '15px'
          }"
        >
        {{item.nome}}
        </span>

        <v-tooltip bottom max-width="220" :disabled="!infoTooltip" :color="settings.layout['tooltip-color']">
          <template v-slot:activator="{ on }">
            <span 
              v-on="on"
              ref="info-speaker"
              class="subtitleCard" 
              :style="{
                color: settings.layout['text-color2'] || '#666D80'
              }"
            >
              {{ getSpeakerInfo }}
            </span>
          </template>
          <div :style="{'font-size': '0.8rem'}">
            <span class="d-block pb-2">
              <b :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF', 'font-weight': '900'}">
                {{ item.cargo }}
              </b>
            </span>

            <span class="d-block" :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF'}">
              {{ item.empresa }}
            </span>
          </div>
        </v-tooltip>

        <div 
          v-if="item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo)"
          :class="['linkedin text-center pt-2']"
        >
          <v-btn 
            fab 
            color="transparent" 
            class="elevation-0" 
            x-small 
            @click.stop="$emit('onClickLinkedin', item)"
          >
            <div class="d-flex justify-center align-center white" style="width: 20px; height: 20px;">
              <i class="fa-brands fa-linkedin bt_color--text" style="font-size: 1.5rem"></i>
            </div>
          </v-btn>
        </div>
      </div> 
    </div>

  </div>
</template>

<script>

export default {
  props: ["item", "settings"],
  computed: {
    getBoxShadow () {
      const shadow = this.settings.layout.shadow
      const distance = this.settings.layout.distance
      if (shadow) return `${distance}px ${distance}px 0 1px ${shadow}`
      else return 'none'
    },

    getSpeakerInfo () {
      if (this.settings.layout.companyPosition) return `${this.item.cargo} - ${this.item.empresa}`
      else return this.item.empresa
    }
  },

  data: () => ({
    hoverId: null,
    infoTooltip: false
  }),

  watch: {
    hoverId (id) {
      const currentSpeaker = this.$refs['current-speaker']
      if (id === this.item.codigo) {
        currentSpeaker.style.backgroundSize = `auto var(--zoom-size) !important`
        const infoSpeaker = this.$refs['info-speaker']
        const isInfoSpeakerEllipsed = infoSpeaker.scrollHeight > infoSpeaker.clientHeight
        this.infoTooltip = isInfoSpeakerEllipsed
      } else {
        currentSpeaker.style.backgroundSize = `auto 100%`
        this.infoTooltip = false
      }
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 200px;
  max-width: 200px;
  transition: all 1s;
  padding-bottom: 12px;
}

.card:hover {
  cursor: pointer;
  transform: translateY(-8px);
}

.speaker-img {
  position: relative;
  transition: all 0.5s;
  width: 200px;
  height: 286px;
  background-position: center;
  background-size: auto 100%;
}

.speaker-img:hover {
  cursor: pointer;
  background-size: auto var(--zoom-size) !important;
}

span {
  display: block;
}

.overlapping {
  position: absolute;
  bottom: 20px;
  right: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: start !important;
  width: 152px;
  transition: all 0.5s ease;
}

.titleCard {
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 30px;
  text-align: left;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  max-height: 100%;  
}

.subtitleCard {
  font-size: 12.5px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
  line-height: 18px;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  max-height: 100%;
  color: #666D80
}

.linkedin {
  top: 0px;
  right: 14px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: start;
  justify-content: start;
}
</style>
